export const colors = [
    {
        category: "Ordered",
        color: "#068475"
    },
    {
        category: "Supplied",
        color: "#0087b8"
    },
    {
        category: "Invoiced",
        color: "#8a67c5"
    },
    {
        category: "InvoicedUnapproved",
        color: "#0087b8"
    },
    {
        category: "NotInvoiced",
        color: "#d20000"
    },
]
